import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class SmoothScroll {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.lenis = new Lenis({ anchors: true });
    this.tick = (time) => this.lenis.raf(time * 1000);

    this.lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(this.tick);
    gsap.ticker.lagSmoothing(0);
  }

  destroy() {
    if (!this.lenis) {
      return;
    }

    gsap.ticker.remove(this.tick);
    this.lenis.destroy();
  }
}
